/**
 * Labstep
 *
 * @desc Duplicate a permissionRole
 */

import { PermissionRoleFormCreate } from 'labstep-web/components/PermissionRole/Form/Create';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import { useState } from 'react';
import type { PermissionRoleActionDuplicateProps } from './types';

const PermissionRoleActionDuplicate: React.FC<
  PermissionRoleActionDuplicateProps
> = ({ permissionRole, authenticatedUserEntity }) => {
  const organization =
    authenticatedUserEntity.userOrganizationOrganization;

  return (
    organization && (
      <ModalDefault
        header="Duplicate Role"
        viewComponent={({ toggleModal }) => (
          <ActionComponent
            type="option"
            icon="clone"
            text="Duplicate"
            onClick={toggleModal}
          />
        )}
        content={({ toggleModal }) => (
          <PermissionRoleFormCreate
            organization={organization}
            options={{
              onSuccess: toggleModal,
            }}
            body={{ source_id: permissionRole.guid }}
            onCancel={toggleModal}
          />
        )}
      />
    )
  );
};

export default withAuthenticatedUserEntity(
  PermissionRoleActionDuplicate,
);
